module.exports = __webpack_public_path__ + "img/banner_camera.c3cc03c6.png";